var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useRouter } from '../../hooks/useRouter';
export function XRouterLink(_a) {
    var _b;
    var to = _a.to, rest = __rest(_a, ["to"]);
    var router = useRouter();
    var path = router.getRoute(to);
    if ((_b = path === null || path === void 0 ? void 0 : path.startsWith) === null || _b === void 0 ? void 0 : _b.call(path, 'http')) {
        return React.createElement("a", __assign({ href: path, target: '_blank' }, rest));
    }
    return React.createElement(NavLink, __assign({ to: path }, rest));
}
